import { FDealType } from '../../../../../../../packages/JsonQuery';
import { useSelector } from 'react-redux';
import { FC } from 'react';
import { selectDealType } from 'shared/selectors/jsonQuery';
import { SaleObjectTypeContainer, RentLongObjectTypeContainer } from './containers';

export const ObjectTypeContainer: FC = () => {
  const dealType = useSelector(selectDealType);

  if (dealType === FDealType.Sale) {
    return <SaleObjectTypeContainer />;
  }

  if (dealType === FDealType.RentLongterm) {
    return <RentLongObjectTypeContainer />;
  }

  return null;
};
